import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Input,
  Button,
  Tooltip,
  Select,
  Divider,
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import {
  Supplier,
  get,
  CreateSupplier,
  EditSupplier,
  Customer,
} from "../../../../api";
import { useQuery } from "@tanstack/react-query";
import Password from "../../../../components/general/password";
import { CanShow } from "../../../../components";
import RepseForm from "../../../home/repse";

type UserProps = {
  type: string;
  id?: number | null;
  add: (v: CreateSupplier) => void;
  update: (v: EditSupplier) => void;
};

type PropsTaxRegime = {
  id: number;
  description: string;
};
const SupplierForm = (props: UserProps) => {
  const { type, id, add, update } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [form] = Form.useForm();

  const { isLoading: isLoadingData, data } = useQuery<Supplier>([type], () =>
    get<Supplier>("/suppliers/" + id).then((e) => e.response)
  );
  const { isLoading: isLoadingTax, data: taxRegimeArray } = useQuery<
    PropsTaxRegime[]
  >(["taxregime"], () =>
    get<PropsTaxRegime[]>("/taxRegime").then((e) => e.response)
  );

  const { isLoading: isLoadingCustomers, data: customers } = useQuery<
    Customer[]
  >(["suppliers"], () => get<Customer[]>("/customers").then((e) => e.response));

  useEffect(() => {
    if (type !== "add" && id) {
      form.setFieldsValue({
        username: data?.username,
        address_1: data?.address_1,
        address_2: data?.address_2,
        city: data?.city,
        company_name: data?.company_name,
        email: data?.email,
        phone: data?.phone,
        repse: data?.repse,
        rfc: data?.rfc,
        type: data?.type,
        state: data?.state,
        supplier_type_description: data?.supplier_type_description,
        zip_code: data?.zip_code,
        tax_regime: data?.tax_regime,
        customer: data?.customer_id,
        nrp: data?.nrp
      });
    }
    setIsLoading(false);
  }, [form, data, id, type]);

  const addSupplierFunction = async (values: any) => {
    setIsLoading(true);
    try {
      if (type === "add") {
        // AGREGAR PROVEEDOR
        let requestBody: CreateSupplier = {
          user: {
            email: values.email,
            username: values.username,
            password: values.password,
          },
          supplier: {
            address_1: values.address_1,
            address_2: values.address_2,
            city: values.city,
            company_name: values.company_name,
            phone: values.phone,
            repse: values.repse,
            rfc: values.rfc,
            type: values.type,
            state: values.state,
            zip_code: values.zip_code,
            tax_regime: values.tax_regime,
            customer_id: values.customer,
            nrp: values.nrp,
          },
        };
        await new Promise((resolve) =>
          setTimeout(() => {
            add(requestBody);
            resolve(true);
          }, 0)
        );
      } else {
        // EDITAR PROVEEDOR
        if (id === undefined || id === null) return;
        let requestBody: EditSupplier = {
          address_1: values.address_1,
          address_2: values.address_2,
          city: values.city,
          company_name: values.company_name,
          phone: values.phone,
          repse: values.repse,
          rfc: values.rfc,
          type: values.type,
          state: values.state,
          zip_code: values.zip_code,
          tax_regime: values.tax_regime,
          customer_id: values.customer,
          nrp: values.nrp,
          id: id,
        };
        await new Promise((resolve) =>
          setTimeout(() => {
            update(requestBody);
            resolve(true);
          }, 0)
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (type === "repse" && id) {
    return (
      <RepseForm
        type={"verificar"}
        supplierId={id}
        add={(repse: any) => add}
        update={(repse: any) => update}
      />
    );
  }
  return (
    <Spin
      spinning={
        isLoading || isLoadingData || isLoadingTax || isLoadingCustomers
      }
      tip={<p>Cargando...</p>}
    >
      <Divider />
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addSupplierFunction}
        initialValues={{ active: false }}
      >
        <div>
          <div>
            {type === "add" && <Divider>Usuario</Divider>}
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  label="Correo electrónico:"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese un email",
                    },
                  ]}
                >
                  <Input
                    type={"email"}
                    placeholder="Ingresa tu información"
                    disabled={type !== "add"}
                  />
                </Form.Item>
              </Col>
            </Row>
            {type === "add" && <Password type="supplier" />}
            <Divider>Información proveedor</Divider>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Nombre de proveedor:"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese un nombre",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type !== "add"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Empresa:"
                  name="company_name"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese un nombre de empresa",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Tipo:"
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese tipo",
                    },
                  ]}
                >
                  <Select
                    placeholder="Selecciona una opción"
                    disabled={type === "watch"}
                    options={[
                      { value: 1, label: "Persona moral" },
                      { value: 2, label: "Persona física" },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item
                  label="RFC:"
                  name="rfc"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese RFC",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Número de Registro Patronal:"
                  name="nrp"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese Número de Registro Patronal",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label={
                    <span>
                      Teléfono:&nbsp;
                      <Tooltip title="El número telefónico debe contener 10 dígitos">
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingresa número telefónico",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                {taxRegimeArray && (
                  <Form.Item
                    label="Régimen fiscal:"
                    name="tax_regime"
                    rules={[
                      {
                        required: true,
                        message: "Por favor seleccione Régimen fiscal",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      disabled={type === "watch"}
                    >
                      {taxRegimeArray.map((e: any) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.id + " " + e.description}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
            </Row>
            <CanShow roles={["Admin", "Financial Advisor"]}>
              <Col xs={24} md={24}>
                {customers && (
                  <Form.Item
                    label="Clientes:"
                    name="customer"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'Por favor seleccione clientes',
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      disabled={type === "watch"}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {customers.map((e: any) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.company_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col>
            </CanShow>
          </div>
          <Divider>Dirección</Divider>
          <div>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Estado:"
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese Estado",
                    },
                  ]}
                >
                  <Input
                    placeholder="Selecciona una opción"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Ciudad:"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese Ciudad",
                    },
                  ]}
                >
                  <Input
                    placeholder="Selecciona una opción"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label={
                    <span>
                      CP:&nbsp;
                      <Tooltip title="El código postal debe contener 5 dígitos">
                        <QuestionCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                  name="zip_code"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese un código postal",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    maxLength={5}
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  label="Dirección:"
                  name="address_1"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese Dirección",
                    },
                  ]}
                >
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item label="Dirección 2:" name="address_2">
                  <Input
                    placeholder="Ingresa tu información"
                    disabled={type === "watch"}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Row>
            <Col span={24}>
              <Form.Item>
                <Row justify="end">
                  <Button
                    htmlType="submit"
                    className="btn-add"
                    disabled={type === "watch" || isLoading}
                  >
                    Guardar
                  </Button>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Spin>
  );
};

export default SupplierForm;
